export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const PARTNER_ACCOUNT_ID_STORAGE_KEY = "loginPartnerAccountId";
export const IS_SIDEBAR_COLLAPSED = "shell:is-sidebar-collapsed";
